import { render, staticRenderFns } from "./Selbstauskunft.vue?vue&type=template&id=b69027ac&scoped=true&"
import script from "./Selbstauskunft.vue?vue&type=script&lang=js&"
export * from "./Selbstauskunft.vue?vue&type=script&lang=js&"
import style0 from "./Selbstauskunft.vue?vue&type=style&index=0&id=b69027ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69027ac",
  null
  
)

export default component.exports
import {QPage} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage})
